import type { IconProps } from './types/types';
import IconWrapper from './wrapper/SvgIconWrapper';

const DoubleSquareIcon = (props: IconProps) => {
  return (
    <IconWrapper {...props}>
      <path
        d="M5 7C5 5.89543 5.89543 5 7 5H14C15.1046 5 16 5.89543 16 7V14C16 15.1046 15.1046 16 14 16H7C5.89543 16 5 15.1046 5 14V7Z"
        fill="none"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14 7H7V14H14V7ZM7 5C5.89543 5 5 5.89543 5 7V14C5 15.1046 5.89543 16 7 16H14C15.1046 16 16 15.1046 16 14V7C16 5.89543 15.1046 5 14 5H7Z"
        fill={props.color}
      />
      <path
        d="M0 2C0 0.895431 0.895431 0 2 0H9C10.1046 0 11 0.895431 11 2V9C11 10.1046 10.1046 11 9 11H2C0.895431 11 0 10.1046 0 9V2Z"
        fill="none"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 2H2V9H9V2ZM2 0C0.895431 0 0 0.895431 0 2V9C0 10.1046 0.895431 11 2 11H9C10.1046 11 11 10.1046 11 9V2C11 0.895431 10.1046 0 9 0H2Z"
        fill={props.color}
      />
    </IconWrapper>
  );
};

export default DoubleSquareIcon;
